module.exports = __webpack_public_path__ + "static/media/trash-red.3a1976bf.svg";